import { ref } from 'vue';
import { defineStore } from 'pinia';

// Services
import { getReviews } from '@/services/ReviewService';

// The admin summary behind Mapping: how many reviews are waiting (the nav badge), the total of a one-review
// page of them. The reviews are admin only, so it's read for admins only: when the sidebar first shows, when Mapping
// decisions opens, and after each review is resolved. A failed read keeps the last.
export const useAdminSummaryStore = defineStore('adminSummary', () => {
    const count = ref(0);

    async function refresh() {
        try {
            count.value = (await getReviews({ status: 'pending', page: 1, pageSize: 1 })).total;
        } catch (error) {
            if (!error.response) console.error('Error fetching the review count:', error);
        }
        return count.value;
    }

    return { count, refresh };
});
